import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-smsCarrier-lookup',
  templateUrl: './micro-smsCarrier-lookup.component.html'
})
export class MicroSmsCarrierLookupComponent  {

  @Input()
  smsCarrierId:any;
}
